import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, input, model } from "@angular/core";

export interface RadioOption<T extends string = string> {
  value: T;
  label: string;
}

@Component({
  selector: "line-chart-radio-buttons",
  template: `
    @for (option of options(); track option.value) {
      <div class="item" [class.active]="selected() === option.value" (click)="selected.set(option.value)">
        {{ option.label | translate }}
      </div>
    }
  `,
  styleUrl: "./line-chart-radio-buttons.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class LineChartRadioButtons<T extends string> {
  readonly options = input.required<RadioOption<T>[]>();
  readonly selected = model.required<T>();
}
